import React from 'react';
import { useNewsNavigation } from '../../hooks/useNewsNavigation';
import { NewsMainPageContainer } from '../../containers/news/NewsMainPageContainer';
import { logNewsEvent } from '../../services/news';

/** The Navigation NewsMainPage is the home page for the news feature (subdomain) */
export const NewsMainPage = () => {
    const newNavigation = useNewsNavigation();
    logNewsEvent("Main");

    return <NewsMainPageContainer {...newNavigation} />;
}